import { type CommentAttributes } from './generated/CommentAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Comment extends CommentAttributes {}

@model
class Comment extends ApplicationModel {
  // Start auto-generated
  static typename: 'Comment' = 'Comment';
  get typename(): 'Comment' {
    return 'Comment';
  }

  static internalTypename: 'Comment' = 'Comment';
  get internalTypename(): 'Comment' {
    return 'Comment';
  }

  static inputType = 'CommentAttributes!';

  static fields = {
    body: attr({ writable: true, readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    commentable: attr.belongsTo({
      writeShape: ['id', 'typename'],
      readable: true,
      typename: [
        'Annotation',
        'BusinessModel',
        'Competitor',
        'DiscoveryInterview',
        'Epic',
        'Feature',
        'Goal',
        'Idea',
        'IdeaTheme',
        'Initiative',
        'Iteration',
        'KeyResult',
        'Page',
        'PdlcStep',
        'Persona',
        'Poll',
        'Presentation',
        'ProgramIncrement',
        'Release',
        'ReleasePhase',
        'Requirement',
        'Task',
        'Unimplemented',
      ],
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default Comment;
